(() => {
 if (window.tmLedNumberOrderReady) return;
 window.tmLedNumberOrderReady = true;
 const rootFor = form => form?.querySelector('[data-tm-led-order]');
 function sync(root, value) {
  const form = document.getElementById(root.dataset.formId);
  const input = root.querySelector('[data-led-order-address]');
  if (value !== undefined) input.value = value;
  const digits = input.value.replace(/[^0-9]/g, '').slice(0,5);
  input.value = digits;
  const preview = document.getElementById('tmLedInput');
  if (preview && preview.value !== digits) { preview.value = digits; preview.dispatchEvent(new Event('input', {bubbles:true})); }
  if (!form) return 0;
  const quantity = form.elements.namedItem('quantity');
  if (quantity) { quantity.value = String(digits.length || 1); quantity.readOnly = true; }
  const selected = root.querySelector('[data-led-order-power]').selectedOptions[0];
  const amount = digits.length * Number(root.dataset.unitPrice) + Number(selected.dataset.price);
  root.querySelector('[data-led-order-summary]').textContent = digits.length
   ? digits.length + ' digits × $100 + selected power: ' + new Intl.NumberFormat('en-US', {style:'currency', currency:root.dataset.currency || 'USD'}).format(amount / 100) + ' before tax and shipping.'
   : 'Enter your address to calculate the total.';
  return digits.length;
 }
 document.addEventListener('input', event => {
  if (event.target.id === 'tmLedInput') {
   const root = document.querySelector('[data-tm-led-order]');
   if (root) sync(root, event.target.value);
  } else {
   const root = event.target.closest('[data-tm-led-order]') || rootFor(event.target.form);
   if (root) sync(root);
  }
 });
 document.addEventListener('change', event => {
  const root = event.target.closest('[data-tm-led-order]') || rootFor(event.target.form);
  if (root) sync(root);
 });
 document.addEventListener('submit', async event => {
  const form = event.target, root = rootFor(form);
  if (!root) return;
  event.preventDefault(); event.stopImmediatePropagation();
  if (root.dataset.busy === 'yes') return;
  const count = sync(root), input = root.querySelector('[data-led-order-address]');
  if (!count || !input.reportValidity()) { input.focus(); return; }
  const data = new FormData(form), id = Number(data.get('id'));
  const error = root.querySelector('[data-led-order-error]');
  error.hidden = true;
  if (!id) { error.textContent = 'Choose a size and LED color.'; error.hidden = false; return; }
  const properties = {};
  for (const [key,value] of data.entries()) {
   const match = key.match(/^properties\[(.+)\]$/);
   if (match) properties[match[1]] = value;
  }
  properties['Digit count'] = String(count);
  const items = [{id, quantity:count, properties}];
  const power = root.querySelector('[data-led-order-power]').selectedOptions[0];
  if (power.dataset.variant) items.push({id:Number(power.dataset.variant), quantity:1, properties:{'For house numbers':input.value}});
  root.dataset.busy = 'yes';
  const button = form.querySelector('[type="submit"]');
  if (button) button.disabled = true;
  try {
   const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
   const result = await response.json();
   if (!response.ok) throw new Error(result.description || 'Unable to add your numbers.');
   window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
  } catch (failure) {
   error.textContent = failure.message; error.hidden = false;
   root.dataset.busy = 'no'; if (button) button.disabled = false;
  }
 }, true);
 const init = () => document.querySelectorAll('[data-tm-led-order]').forEach(root => sync(root));
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
 document.addEventListener('shopify:section:load', init);
})();